import { useEffect } from 'react';
import { useAxios, isServerError } from 'src/hooks/use-axios';
import { ShipperUser } from 'src/pages/shipper-admin/details/types';

export function useShipperUser(id: string) {
  const shipperUser = useAxios(
    (axios, signal) =>
      axios.request<ShipperUser>({
        signal,
        url: `${PRISMA_CONFIG.oldBackendUrl}/shippers/user/${id}`,
      }),
    {
      neededOnPageLoad: true,
      onError(error) {
        // return 500 with UNKNOWN_SHIPPER_USER for deactivated users :(
        if (
          isServerError(error) &&
          error.response.status === 500 &&
          error.response.data &&
          (error.response.data as any).message === 'UNKNOWN_SHIPPER_USER'
        ) {
          return error;
        } else {
          throw error;
        }
      },
    }
  );

  useEffect(() => {
    shipperUser.execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return shipperUser;
}

export type ShipperUserRequest = ReturnType<typeof useShipperUser>;
